// eslint-disable-next-line import/no-extraneous-dependencies
import React, {
    HTMLAttributes,
    ReactElement, ReactNode,
} from "react";

import { Data, useDraggable } from "@dnd-kit/core";
import classNames from "classnames";

export interface DraggableProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    children?: ReactNode,
    dragClassName?: string;
    item: Data;
    isEnabled: boolean;
}

const Draggable = React.forwardRef((
    args: DraggableProps,
    ref: React.ForwardedRef<HTMLElement>,
): ReactElement => {
    const {
        children,
        id,
        style,
        className,
        dragClassName,
        item,
        isEnabled,
        ...rest
    } = args;

    const {
        attributes, listeners, setNodeRef, transform, isDragging,
    } = useDraggable({
        id,
        data: item,
        disabled: !isEnabled,
    });

    const mergedRef = (element: HTMLElement | null) => {
        setNodeRef(element);
        if (typeof ref === "function") {
            ref(element);
        } else if (ref) {
            // eslint-disable-next-line no-param-reassign
            ref.current = element;
        }
    };

    return (
        <div
            ref={mergedRef}
            className={classNames(className, isDragging ? dragClassName : "")}
            style={{
                ...style,
                transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
            }}
            {...attributes}
            {...listeners}
            {...rest}
        >
            {children}
        </div>
    );
});

Draggable.defaultProps = {
    dragClassName: "",
    isEnabled: true,
};

export default Draggable;
